import React, { useMemo } from 'react'
import { ReactComponent as MoneyCheckDollarPenIcon } from 'assets/MoneyCheckDollarPen.svg'
import { useCSDetailsCachedData } from 'components/configured-service/useCSDetailsCachedData'
import { selectPurchaseOrderNumber } from 'data/configured-service/configuredServiceDetailsSelectors'
import T from 'T'
import ServiceDetailChip from 'components/configured-service/layout/ServiceDetailChip'

const ServicePONumberChip = ({ id, ...props }) => {
  const { data = {} } = useCSDetailsCachedData({ id })
  const purchaseOrderNumber = useMemo(() => selectPurchaseOrderNumber(data), [data])

  return (
    <ServiceDetailChip
      IconComponent={MoneyCheckDollarPenIcon}
      label={purchaseOrderNumber ? `#${purchaseOrderNumber}` : null}
      tooltip={T.PURCHASE_ORDER_LABEL}
      {...props}
    />
  )
}

export default ServicePONumberChip
